<template>
  <b-button v-bind="$attrs" v-b-popover.hover.top="text" title="Popover Title">
    <i class="fad fa-question-circle"></i>
  </b-button>
</template>

<script>

export default {
  name: 'LoadingButton',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>
